import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import RangeButtons from './RangeButtons';
import OverlaySpinner from '../../OverlaySpinner';
import DatePicker from '../../DatePickerV2';
import { t } from '../../../../modules/infra/i18n';

const RangeFilter = ({
  isFetching,
  firstFrom,
  firstTo,
  secondFrom,
  secondTo,
  setFirstRange,
  setSecondRange,
  submitRange,
  hasCompare,
  filters,
  selectedFilter,
  onFilterChange,
  endingDateMax,
  isDirty,
}) => (
  <div className="layout layout--bottom layout--auto u-1/1-medium-and-down u-margin-0">
    <OverlaySpinner display-if={isFetching} />
    <div className="layout__item u-1/1-medium-and-down u-p-0 u-mr-">
      <RangeButtons
        filters={filters}
        selectedFilter={selectedFilter}
        onFilterChange={onFilterChange}
        disabled={isFetching}
      />
    </div>
    <div className="layout__item u-1/1-medium-and-down u-p-0">
      <div className="layout layout--auto layout--small layout--middle u-1/1-medium-and-down u-margin-0 c-report-filters o-flexbox--content-align-center">
        <div
          className={classnames('c-report-filters__item', {
            'is-disabled': isFetching,
            'u-margin-0': !(hasCompare && secondFrom),
          })}
        >
          <DatePicker
            from={moment(firstFrom).toDate()}
            to={moment(firstTo).toDate()}
            onChange={setFirstRange}
            endDate={endingDateMax}
            disabled={isFetching}
            range
            presets={false}
          />
        </div>
        <div className="zeta u-mr u-text-center medium-and-down-mb-" display-if={hasCompare && secondFrom}>
          {t('reports:analytics.vs')}
        </div>
        <div
          display-if={hasCompare && secondFrom}
          className={classnames('filters__item', { 'is-disabled': isFetching })}
        >
          <DatePicker
            from={moment(secondFrom).toDate()}
            to={moment(secondTo).toDate()}
            onChange={setSecondRange}
            endDate={endingDateMax}
            disabled={isFetching}
            range
            presets={false}
          />
        </div>
        <div className="c-form-input-group__item large-and-up-ml- medium-and-down-mt-">
          <button
            type="button"
            className="c-btn c-btn--medium u-1/1-medium-and-down"
            onClick={submitRange}
            disabled={isFetching || !isDirty}
            data-automation-id="button:submitRange"
          >
            {t('common:save')}
          </button>
        </div>
        <div className="c-form-input-group__item" />
      </div>
    </div>
  </div>
);

RangeFilter.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedFilter: PropTypes.string.isRequired,
  submitRange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  firstFrom: PropTypes.string,
  firstTo: PropTypes.string,
  secondFrom: PropTypes.string,
  secondTo: PropTypes.string,
  setFirstRange: PropTypes.func.isRequired,
  setSecondRange: PropTypes.func.isRequired,
  hasCompare: PropTypes.bool,
  endingDateMax: PropTypes.instanceOf(Date).isRequired,
  isDirty: PropTypes.bool.isRequired,
};

RangeFilter.defaultProps = {
  firstFrom: '',
  firstTo: '',
  secondFrom: '',
  secondTo: '',
  hasCompare: false,
};

export default RangeFilter;
